import { SearchForm } from "../Applicants/Applicants";
import styled from "@emotion/styled";
import { PaymentTable } from "../Payment";
import { useQuery } from "@tanstack/react-query";
import apiCall from "../../../utils/apiCall";
import { AxiosError } from "axios";
import { CircularProgress } from "@mui/material";
import {
  DateFilter,
  Button,
  FilterDropDown,
  Loading,
} from "../../../ui-components";
import { useContext, useState } from "react";
import {
  ExNyRoute,
  PrRoute,
  ExRoute,
  AcRoute,
  MiRoute,
  CoRoute,
} from "../../../utils/allRouteId";
import { RouteResponse } from "../../../types/index";
import { FetchAllRoutes, reOrderFetchedData } from "../../../hooks/FetchData";
import { NotificationContext } from "../../../providers/notification";
import { apiRequest, apiFormRequest, config } from "../../../api";
import { number } from "yup";
import fileDownload from "js-file-download";

interface DisplayPaymentProps {
  setRouteName: React.Dispatch<React.SetStateAction<string>>;
}

const DisplayPayment = ({ setRouteName }: DisplayPaymentProps) => {
  const [route, setRoute] = useState(Number(ExNyRoute));
  const [date, setDate] = useState({ start: "1909-08-13", end: "2100-08-13" });
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [routeNameInt, setRouteNameInt] = useState("");
  const [d_loading, set_d_loading] = useState<boolean>(false);
  const [file, setFile] = useState<any>("");
  const { showNotification } = useContext(NotificationContext);
  const [channel, set_channel] = useState<any>("");
  const [selected_status, set_selected_status] = useState<any>("");

  const { isLoading, data } = FetchAllRoutes();

  const reOrderedAllRoutes = data
    ? reOrderFetchedData((data as RouteResponse)?.Data)
    : [];

  const allRoutes = isLoading
    ? []
    : reOrderedAllRoutes.map((item) => {
        return { name: item?.RouteName, val: item?.RouteId };
      });

  const getAllPaymentHistory = async () => {
    return (await apiCall().get(
      `Payment/GetAllPaymentMade?routeId=${route}&startDate=${date?.start}&endDate=${date?.end}&PageSize=${pageSize}&PageNumber=${currentPage}`
    )) as any;
  };

  const getAllPaymentHistoryQuery = useQuery(
    ["get-All-Payments", route, date?.start, date?.end, currentPage],
    getAllPaymentHistory,
    { retry: 0 }
  );

  const paymentHistoryData = getAllPaymentHistoryQuery?.data?.data;

  const getAllPaymentHistoryError =
    getAllPaymentHistoryQuery?.error as AxiosError;
  const getAllPaymentHistoryErrorMessage = getAllPaymentHistoryError?.message;

  const handleRouteSwitch = (route: { val: number; name: string }) => {
    setCurrentPage(1);
    setDate({ start: "1909-08-13", end: "2100-08-13" });
    setRoute(route.val);
    setRouteName(route?.name);
    setRouteNameInt(route?.name);
    set_channel(channel.name);
    set_selected_status("status");
  };
  const handleDownload = () => {
    set_d_loading(true);
    let body: any = {
      routeId: number,
    };
    body = JSON.stringify({});
    let params: any = [
      {
        startDate: "1909-08-13",
      },
      { endDate: "2100-08-13" },
    ];
    if (channel && channel?.name) params.push({ paymentChannel: channel.name });
    if (selected_status && selected_status?.name)
      params.push({ status: selected_status });
    apiRequest(
      `api/Payment/DownloadAllPaymentHistory?${params
        .map((e: any) => `${Object.keys(e)[0]}=${Object.values(e)[0]}`)
        .join("&")}`,
      "POST",
      body,
      config,
      true
    )
      .then((data: any) => {
        if (!data?.Message) {
          fileDownload(
            data,
            `all-payment-history${Math.floor(Math.random() * 10000) + 1}.xlsx`
          );
          showNotification({
            message: "File downloading...",
            type: "success",
          });
        } else {
          showNotification({
            message: data.Message || "No file to download",
            type: "error",
          });
        }

        set_d_loading(false);
      })
      .catch((error: any) => {
        showNotification({
          message: "Sorry File cannot be downloaded",
          type: "error",
        });
        set_d_loading(false);
      });
  };

  return (
    <>
      <TopWrapper>
        <SearchForm />
        <FilterDropDown
          onChange={handleRouteSwitch}
          options={allRoutes}
          text={routeNameInt ? `${routeNameInt}` : "Membership Route"}
          bg="#11643C"
          color="#fff"
        />
      
        <FilterDropDown
          onChange={set_selected_status}
          options={[
            { name: "Successful", val: 1 },
            { name: "Failed", val: 2 },
            { name: "Unknown", val: 3 },
          ]}
          bg="#11643C"
          color="#fff"
          text="Status"
        />
        <FilterDropDown
          onChange={set_channel}
          options={[
            { name: "CyberPay", val: 1 },
            { name: "Deposit", val: 2 },
            { name: "Others", val: 3 },
          ]}
          bg="#0A3922"
          color="#fff"
          text="Channel"
        />
        <DateFilter onChange={setDate} />
     <Button
          style={{ padding: "17px 10px" }}
          onClick={handleDownload}
          children={d_loading ? "Loading..." : "Download"}
          border="#E2E4E9"
          bg="#0A3922"
          color="#fff"
        />

      </TopWrapper>

      {getAllPaymentHistoryQuery.isLoading ? (
        <CircularProgress
          sx={{
            fontSize: "1rem",
            marginInline: "auto",
            display: "block",
            marginBlock: "2rem",
          }}
        />
      ) : getAllPaymentHistoryQuery.isError ? (
        <StyledError>{getAllPaymentHistoryErrorMessage}</StyledError>
      ) : (
        <PaymentTable
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          data={paymentHistoryData}
        />
      )}
    </>
  );
};

export default DisplayPayment;

const TopWrapper = styled("div")`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 10px 10px 48px 0px;
  flex-wrap: wrap;
`;

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;
